<template>
  <div class="checkin-day">
    <!-- TITULO -->
    <b-row class="form--title">
      <b-col class="form--title__size">
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title__text"
        >
          Dia de check-in

          <InfoTooltip
            :tooltipMinWidth="'308'"
            text="Quais dias da semana o usuário poderá efetuar check in nesta tarifa? Caso nenhum dia da semana seja selecionado, o sistema entenderá que a regra tarifária está disponível para todos os dias da semana."
          />

          <PmwParagraph class="form--subtitle" size="paragraph-40">
            Quais os dias da semana o usuário pode efetuar check-in nessa
            tarifa?
          </PmwParagraph>
        </PmwHeading>

        <!-- INPUT DE SELEÇÃO DE DIAS -->
        <b-row class="form--row">
          <PmwFormSelect
            v-model="weekDays"
            :options="weekDaysOptions"
            :search="true"
            :multiple="true"
            label="Dias da semana"
            placeholder="Selecione"
            class="form--input form--input__select"
          />
        </b-row>
      </b-col>

      <!-- TITULO DE ANTECEDENCIA -->
      <b-col class="form--title__size">
        <PmwHeading
          size="paragraph-80"
          weight="weight-light"
          class="form--title__text"
        >
          Antecedência

          <PmwParagraph class="form--subtitle" size="paragraph-40">
            Quantos dias antes da data de check-in o usuário pode acessar essa
            tarifa?
          </PmwParagraph>
        </PmwHeading>

        <b-row class="form--row">
          <!-- INPUT DE MINIMO DE NOITES DE ANTECEDENCIA -->
          <b-col>
            <PmwFormInput
              v-model.number="fluctuationData.antecedenciaDe"
              label="Miníma"
              placeholder="00"
              size="small"
              type="number"
              sufix="dias"
              class="form--input"
            />
          </b-col>

          <!-- INPUT DE MAXIMO DE NOITES DE ANTECEDENCIA -->
          <b-col>
            <PmwFormInput
              v-model.number="fluctuationData.antecedenciaAte"
              label="Máxima"
              placeholder="00"
              size="small"
              type="number"
              sufix="dias"
              class="form--input"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="form--title__spacing">
      <!-- TITULO DE TARIFA DE ULTIMA HORA -->
      <PmwHeading
        size="paragraph-80"
        weight="weight-light"
        class="form--title__text"
      >
        Tarifa de última hora

        <InfoTooltip
          :tooltipMinWidth="'308'"
          text="Quando selecionado, este campo faz com que a tarifa seja apenas ativada para buscas em que o check in será efetuado no mesmo dia da reserva. Defina o horário em que a tarifa de última hora será ativada"
        />

        <PmwParagraph class="form--subtitle" size="paragraph-40">
          Defina que, esta tarifa será exibida somente para usuários que estão
          buscando uma reserva para o mesmo dia. Para ser ativada, a data de
          check-in da pesquisa deve coincidir com a data em que o usuário está
          fazendo a busca.
        </PmwParagraph>
      </PmwHeading>
    </b-row>

    <!-- ATIVAÇÃO DE TARIFA DE ULTIMA HORA -->
    <b-row class="form--title">
      <InputCheckbox
        v-model="lastMinuteRate"
        :checked="lastMinuteRate"
        :inputValue="true"
        label="Ativar tarifa de última hora"
        name="mobile"
        class="form--input__checkbox"
      />
    </b-row>

    <!-- ATIVAÇÃO DE TARIFA DE ULTIMA HORA -->
    <b-row v-if="lastMinuteRate" class="form--row">
      <!-- <PmwFormInput
        v-model="fluctuationData.lastMinute"
        label="Hora de ativação"
        size="small"
        type="time"
        class="form--input"
      /> -->

      <PmwFormSelect
        v-model="lastMinute"
        :options="hoursOptions"
        :search="true"
        label="Hora de ativação"
        placeholder="Selecione"
        class="form--input form--input__select"
      />

      <!-- DESCRIÇÃO DE TARIFA DE ULTIMA HORA -->
      <PmwFormInput
        v-model="fluctuationData.lastMinuteDescricao"
        :showCounter="true"
        maxlength="150"
        label="Descrição last minute (Site Letsbook)"
        placeholder="Fale um pouco sobre"
        size="large"
        class="form--input form--input__description"
      />
    </b-row>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'
import { removeStringAccents } from '@/helpers/string'

export default {
  name: 'CheckInDay',
  components: {
    PmwHeading,
    PmwFormInput,
    PmwFormSelect,
    PmwParagraph,
    InfoTooltip,
    InputCheckbox
  },

  props: {
    fluctuationData: {
      type: Object,
      default: () => ({})
    },

    /** Dias da semana disponíveis */
    weekDaysOptions: {
      type: Array,
      default: () => [
        { text: 'Domingo', value: 1 },
        { text: 'Segunda', value: 2 },
        { text: 'Terça', value: 3 },
        { text: 'Quarta', value: 4 },
        { text: 'Quinta', value: 5 },
        { text: 'Sexta', value: 6 },
        { text: 'Sábado', value: 7 }
      ]
    }
  },

  data() {
    return {
      weekDays: [],

      isEditing: false,

      lastMinuteRate: false,

      lastMinute: null,

      hoursOptions: Array.from({ length: 24 }, (_, i) => ({
        text: `${i.toString().padStart(2, '0')}:00`,
        value: i
      }))
    }
  },

  watch: {
    lastMinuteRate(newVal) {
      if (!newVal) {
        this.lastMinute = []
        this.fluctuationData.lastMinuteDescricao = null
      }
    },

    weekDays: {
      handler() {
        this.updateFluctuationData()
      },
      deep: true
    },

    lastMinute(newVal) {
      this.fluctuationData.lastMinute = newVal.value
    },

    isEditing: {
      handler() {
        if (this.isEditing) {
          /** Preencha weekDays com base nas informações de fluctuationData */
          this.weekDays = this.weekDaysOptions
            .filter(
              (day) =>
                this.fluctuationData[`checkin${removeStringAccents(day.text)}`]
            )
            .map((day) => day)
        }
      },
      immediate: true
    }
  },

  created() {
    /** Se for edição */
    if (this.$route.params.rateId) {
      this.isEditing = true
    }

    /** Define como todos os dias no caso de criação ou se não tiver dias configurados */
    if (!this.$route.params.rateId) {
      this.weekDays = this.weekDaysOptions.map((day) => day)
    }

    if (this.fluctuationData.lastMinute) {
      this.lastMinuteRate = true
      this.lastMinute = {
        text: `${this.fluctuationData.lastMinute}:00`,
        value: this.fluctuationData.lastMinute
      }
    } else if (
      this.fluctuationData.lastMinuteDescricao &&
      !this.lastMinuteRate
    ) {
      this.lastMinuteRate = true
    }
  },

  methods: {
    updateFluctuationData() {
      /** Define todos os dias como false */
      this.fluctuationData.checkinDomingo = false
      this.fluctuationData.checkinSegunda = false
      this.fluctuationData.checkinTerca = false
      this.fluctuationData.checkinQuarta = false
      this.fluctuationData.checkinQuinta = false
      this.fluctuationData.checkinSexta = false
      this.fluctuationData.checkinSabado = false

      /** Atualizar com os dias selecionados */
      this.weekDays.forEach((day) => {
        switch (day.value) {
          case 1:
            this.fluctuationData.checkinDomingo = true
            break
          case 2:
            this.fluctuationData.checkinSegunda = true
            break
          case 3:
            this.fluctuationData.checkinTerca = true
            break
          case 4:
            this.fluctuationData.checkinQuarta = true
            break
          case 5:
            this.fluctuationData.checkinQuinta = true
            break
          case 6:
            this.fluctuationData.checkinSexta = true
            break
          case 7:
            this.fluctuationData.checkinSabado = true
            break
          default:
            break
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.checkin-day {
  min-width: 900px;
  .form {
    &--subtitle {
      font-size: font-size('size-small');
      font-weight: font-weight('weight-normal');
      color: pmw-colors(grey-80);
      line-height: 21px;
      margin-top: 8px;
    }

    &--input {
      &__checkbox {
        width: 200px;
        max-width: 200px;
      }

      &__description {
        width: 600px;
        max-width: 600px;
      }

      /** Alterar cores novas do select */
      ::v-deep {
        .pmw-select--button__caret-sort-up,
        .pmw-select--button__show {
          border-bottom-color: pmw-colors('blue-100');
        }
        .pmw-select--button:focus {
          border-color: pmw-colors('blue-100');
          border-bottom-color: pmw-colors('blue-100');
        }
        .pmw-select-options--item__hover:hover,
        .pmw-select-options--item__checked {
          background-color: pmw-colors('blue-100') !important;
        }
        .pmw-form-field--label {
          font-weight: font-weight('weight-medium');
        }
        .form-field--label-wrapper {
          line-height: 21px;
          margin-bottom: 3px;
        }
        .pmw-input {
          background: $white;
        }
        .pmw-input--clear {
          z-index: 0;
        }
        .pmw-input__focus {
          border-color: $pmw-blue;
        }

        .pmw-input--field {
          background: $pmw-white;

          &:focus {
            border-color: $pmw-blue;
          }
        }

        .pmw-input__disabled {
          input {
            background: pmw-colors('grey-20');
            color: $pmw-gray-darker;
          }
        }

        .pmw-custom-tooltip {
          line-height: 18px;
        }
      }

      &__select {
        width: 250px;
        max-width: 250px;

        &.error {
          ::v-deep {
            .pmw-select--button {
              border-bottom-color: pmw-colors('error-100');
              border-bottom-width: 2px;
            }
          }
        }
      }
    }

    &--row {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 28px;
    }

    &--title {
      margin-bottom: 24px;
      min-width: auto;
      display: inline-flex;

      &__spacing {
        margin-top: 16px;
      }

      &__text {
        margin-bottom: 24px;
      }

      &__size {
        width: 450px;
      }
    }
  }
}
</style>
